import Breadcrumbs, { type Crumb } from "@/components/base/Breadcrumbs";

interface PageHeroProps {
  eyebrow?: string;
  title: string;
  description: string;
  crumbs: Crumb[];
}

export default function PageHero({ eyebrow, title, description, crumbs }: PageHeroProps) {
  return (
    <section className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-8 md:py-14">
        <Breadcrumbs items={crumbs} />
        <div className="mt-6 flex flex-col gap-4">
          {eyebrow ? (
            <span className="inline-flex items-center gap-2 text-xs font-medium tracking-[0.28em] text-primary-600">
              <span className="h-px w-6 bg-primary-500" />
              {eyebrow}
            </span>
          ) : null}
          <h1 className="max-w-3xl font-heading text-3xl font-bold leading-tight text-foreground-950 text-balance md:text-4xl">
            {title}
          </h1>
          <p className="max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">{description}</p>
        </div>
      </div>
    </section>
  );
}